import loader from '~shared-assets/animations/loader.svg';

import { CSSProperties } from 'react';

import { BodilColor } from '~src/branding';

type LoaderSize = 'small' | 'default' | 'large';

type Props = {
  size?: LoaderSize;
  width?: number | string;
  height?: number | string;
  color?: string;
  style?: CSSProperties;
};
export const Loader = ({ size = 'default', width, height, color = BodilColor.ui.action.default, style }: Props) => {
  const background = `url("${loader}")`;

  return (
    <div
      style={{
        backgroundColor: color,
        WebkitMask: background,
        WebkitMaskRepeat: 'no-repeat',
        WebkitMaskPosition: 'center',
        WebkitMaskSize: 'cover',
        maskImage: background,
        maskSize: 'cover',
        maskRepeat: 'no-repeat',
        width: width ?? dimension(size),
        height: height ?? dimension(size),
        ...style,
      }}
    />
  );
};

const dimension = (size: LoaderSize) => {
  switch (size) {
    case 'small':
      return 24;
    case 'large':
      return 64;
    case 'default':
    default:
      return 40;
  }
};
